"use strict";
/*
 * Created on 23.05.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var StringLengthValidator_1 = require("../../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../../core/model/DomainObject");

var utils_1 = require("../../../core/utils");

var PromotionStateEnum_1 = require("../../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../../promotion/model/StoreSpecificationEnum");

var SupplierAgreement_1 = require("../../../supply/model/SupplierAgreement");

var WindowStateEnum_1 = require("../../../window/model/WindowStateEnum"); //tslint:disable:max-classes-per-file

/**
 * Projection of Promotion for performance reports.
 */


var PerfPromotion =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PerfPromotion, _DomainObject_1$Domai);

  function PerfPromotion(id, externalId, workflowState, name, promotionTypeId, storeSpecification, dateFrom, dateTo, gosId) {
    var _this;

    _classCallCheck(this, PerfPromotion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PerfPromotion).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.workflowState = workflowState;
    _this.name = name;
    _this.promotionTypeId = promotionTypeId;
    _this.storeSpecification = storeSpecification;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.gosId = gosId;
    return _this;
  }

  _createClass(PerfPromotion, null, [{
    key: "fromPromotion",
    value: function fromPromotion(p) {
      return new PerfPromotion(p.id, p.externalId, p.workflowState, p.name, p.promotionTypeId, p.storeSpecification, p.dateFrom, p.dateTo, p.groupOfSitesId);
    }
  }, {
    key: "fromMat",
    value: function fromMat(mat) {
      return new PerfPromotion(mat.id, mat.externalId, mat.workflowState, mat.name, mat.promotionTypeId, mat.storeSpecification, mat.dateFrom, mat.dateTo, mat.gosId);
    }
  }]);

  return PerfPromotion;
}(DomainObject_1.DomainObject);

exports.PerfPromotion = PerfPromotion;

PerfPromotion.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PerfPromotion.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    workflowState: builder.opt(builder.senum('workflowState', PromotionStateEnum_1.PromotionStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionWorkflowState)),
    name: builder.str('name'),
    promotionTypeId: builder.str('promotionTypeId'),
    storeSpecification: builder.senum('storeSpecification', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    gosId: builder.lookup('gosId', CodebookLookupSequence_1.CodebookLookupSequence.GroupOfSites)
  };
}(); //tslint:disable:max-classes-per-file

/**
 * Projection of Window for performance reports.
 */


var PerfWindow =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(PerfWindow, _DomainObject_1$Domai2);

  /**
   * @param id
   * @param workflowState
   * @param name
   * @param windowOriginId
   * @param windowTypeId
   * @param mergedWindowIds
   * @param dateFrom
   * @param dateTo
   * @param themeId
   * @param promotionId
   * @param fcApprovalNeeded
   * @param portfolio
   * @param dummy
   * @param simAttrs simulated attributes that were changed during simulation to another value;
   * should be highlighted in report; strings represent names of attributes of {@link SimulationValue} types
   * from {@link WindowSimulation}
   */
  function PerfWindow(id, workflowState, name, windowOriginId, windowTypeId, mergedWindowIds, dateFrom, dateTo, themeId, promotionId, fcApprovalNeeded, portfolio, dummy, // RFC-370 (issue PROMO-5): Names of simulated attributes
  simAttrs) {
    var _this2;

    _classCallCheck(this, PerfWindow);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PerfWindow).call(this));
    _this2.id = id;
    _this2.workflowState = workflowState;
    _this2.name = name;
    _this2.windowOriginId = windowOriginId;
    _this2.windowTypeId = windowTypeId;
    _this2.mergedWindowIds = mergedWindowIds;
    _this2.dateFrom = dateFrom;
    _this2.dateTo = dateTo;
    _this2.themeId = themeId;
    _this2.promotionId = promotionId;
    _this2.fcApprovalNeeded = fcApprovalNeeded;
    _this2.portfolio = portfolio;
    _this2.dummy = dummy;
    _this2.simAttrs = simAttrs;
    return _this2;
  }

  _createClass(PerfWindow, [{
    key: "durationInDays",
    value: function durationInDays() {
      return this.dateTo.diff(this.dateFrom, 'days') + 1;
    }
  }], [{
    key: "fromWindow",
    value: function fromWindow(w) {
      var windowOriginId = w.simulation && w.simulation.originId ? w.simulation.originId : null;
      var simAttrs = w.simulation ? w.simulation.getNamesOfSimulatedAttributes() : immutable_1.List();
      return new PerfWindow(w.id, w.workflowState, w.name, windowOriginId, w.windowTypeId, immutable_1.List(), w.dateFrom, w.dateTo, w.themeId, w.promotionId, w.isFCApprovalRequired(), w.portfolio, w.dummy, simAttrs);
    }
  }, {
    key: "fromMat",
    value: function fromMat(mat) {
      return new PerfWindow(mat.id, mat.workflowState, mat.name, mat.windowOriginId, mat.windowTypeId, mat.mergedWindowIds, mat.dateFrom, mat.dateTo, mat.themeId, mat.promotionId, mat.fcApprovalNeeded, mat.portfolio, mat.dummy, mat.simAttrs);
    }
  }, {
    key: "createMergedWindowNodeId",
    value: function createMergedWindowNodeId(windowIds) {
      if (windowIds.isEmpty()) {
        return '';
      }

      return windowIds.first();
    }
    /**
     * Creates merged window according to description of LOG-7625 (RFC 377) - "Zlucovanie Window".
     * @param windows
     */

  }, {
    key: "createMergedWindow",
    value: function createMergedWindow(windows) {
      if (windows.isEmpty()) {
        throw new Error("No windows to merge!");
      }

      var firstWindow = windows.first();

      if (windows.some(function (w) {
        return w.name !== firstWindow.name;
      })) {
        throw new Error("Merged windows should have the same name: ".concat(windows.map(function (w) {
          return w.id;
        }).join(',')));
      }

      if (windows.some(function (w) {
        return w.portfolio !== firstWindow.portfolio;
      })) {
        throw new Error("Merged windows should have the same portfolio: ".concat(windows.map(function (w) {
          return w.id;
        }).join(',')));
      }

      var windowIds = windows.map(function (w) {
        return w.id;
      });
      return new PerfWindow(PerfWindow.createMergedWindowNodeId(windowIds), null, firstWindow.name, // the same for all merged windows
      null, firstWindow.windowTypeId, // from arbitrary window
      windowIds, firstWindow.dateFrom, // from arbitrary window
      firstWindow.dateTo, // from arbitrary window
      null, utils_1.Utils.VOID_ID, false, firstWindow.portfolio, // the same for all merged windows
      windows.every(function (w) {
        return w.dummy;
      }), windows.flatMap(function (w) {
        return w.simAttrs;
      }).toSet().toList());
    }
  }]);

  return PerfWindow;
}(DomainObject_1.DomainObject);

exports.PerfWindow = PerfWindow;
PerfWindow.EMPTY_LIST = immutable_1.List();

PerfWindow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PerfWindow.name);
  return {
    id: builder.id('id'),
    workflowState: builder.opt(builder.senum('workflowState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    name: builder.trimStr('name', new StringLengthValidator_1.StringLengthValidator(1, 255)),
    windowOriginId: builder.opt(builder.str('windowOriginId')),
    windowTypeId: builder.lookup('windowTypeId', CodebookLookupSequence_1.CodebookLookupSequence.WindowTypes),
    mergedWindowIds: builder.listOf(builder.id('mergedWindowIds')),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    themeId: builder.opt(builder.lookup('themeId', CodebookLookupSequence_1.CodebookLookupSequence.Theme)),
    promotionId: builder.lookup('promotionId', CodebookLookupSequence_1.CodebookLookupSequence.Promotion),
    fcApprovalNeeded: builder.bool('fcApprovalNeeded'),
    portfolio: builder.str('portfolio'),
    dummy: builder.bool('dummy'),
    simAttrs: builder.listOf(builder.str('simAttrs'))
  };
}(); //tslint:disable:max-classes-per-file

/**
 * Projection of WindowItemPosAttributes for performance reports.
 */


var PerfWindowItemPosAttributes =
/*#__PURE__*/
function (_DomainObject_1$Domai3) {
  _inherits(PerfWindowItemPosAttributes, _DomainObject_1$Domai3);

  function PerfWindowItemPosAttributes(posMarginImpactExpected) {
    var _this3;

    var posMechanics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var posType = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, PerfWindowItemPosAttributes);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PerfWindowItemPosAttributes).call(this));
    _this3.posMarginImpactExpected = posMarginImpactExpected;
    _this3.posMechanics = posMechanics;
    _this3.posType = posType;
    return _this3;
  }

  _createClass(PerfWindowItemPosAttributes, null, [{
    key: "fromPosAttributes",
    value: function fromPosAttributes(posAttributes) {
      return new PerfWindowItemPosAttributes(posAttributes.posMarginImpactExpected, posAttributes.posMechanics, posAttributes.posType);
    }
  }]);

  return PerfWindowItemPosAttributes;
}(DomainObject_1.DomainObject);

exports.PerfWindowItemPosAttributes = PerfWindowItemPosAttributes; //tslint:disable:max-classes-per-file

/**
 * Projection of WindowItem for performance reports.
 */

var PerfWindowItem =
/*#__PURE__*/
function (_DomainObject_1$Domai4) {
  _inherits(PerfWindowItem, _DomainObject_1$Domai4);

  /**
   * @param id
   * @param productId
   * @param windowId
   * @param promotionId
   * @param posAttributes
   * @param memberCredits
   * @param promoPrice
   * @param regularPrice
   * @param promoVolume
   * @param simulationId ID of the {@link Simulation} entity if this item is from simulation
   * @param snapshot true if this item is from snapshot
   * @param fcApprovalNeeded
   * @param requestForSecondaryPlacement
   * @param secondaryPlacement
   * @param onPicture
   * @param numberOfSites
   * @param simAttrs simulated attributes that were changed during simulation to another value;
   * should be highlighted in report; strings represent names of attributes of {@param logisticComment
   * @link SimulationValue} types
   * from {@link WindowItemSimulation}
   */
  function PerfWindowItem(id, productId, windowId, promotionId, posAttributes, memberCredits, promoPrice, regularPrice, promoVolume, simulationId, snapshot, fcApprovalNeeded, // RFC-377
  requestForSecondaryPlacement, secondaryPlacement, onPicture, numberOfSites, // RFC-370 (issue PROMO-5)
  simAttrs, // PROMO-397
  logisticComment) {
    var _this4;

    _classCallCheck(this, PerfWindowItem);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PerfWindowItem).call(this));
    _this4.id = id;
    _this4.productId = productId;
    _this4.windowId = windowId;
    _this4.promotionId = promotionId;
    _this4.posAttributes = posAttributes;
    _this4.memberCredits = memberCredits;
    _this4.promoPrice = promoPrice;
    _this4.regularPrice = regularPrice;
    _this4.promoVolume = promoVolume;
    _this4.simulationId = simulationId;
    _this4.snapshot = snapshot;
    _this4.fcApprovalNeeded = fcApprovalNeeded;
    _this4.requestForSecondaryPlacement = requestForSecondaryPlacement;
    _this4.secondaryPlacement = secondaryPlacement;
    _this4.onPicture = onPicture;
    _this4.numberOfSites = numberOfSites;
    _this4.simAttrs = simAttrs;
    _this4.logisticComment = logisticComment;
    return _this4;
  }

  _createClass(PerfWindowItem, [{
    key: "getRegularSales",
    value: function getRegularSales() {
      return this.regularPrice.mul(this.promoVolume);
    }
  }, {
    key: "getPromoSales",
    value: function getPromoSales() {
      return this.promoPrice.mul(this.promoVolume);
    }
  }, {
    key: "getPromoDiscount",
    value: function getPromoDiscount() {
      return this.regularPrice.minus(this.promoPrice).dividedBy(this.regularPrice.dividedBy(100)).floor();
    }
  }], [{
    key: "fromWindowItem",
    value: function fromWindowItem(wi, snapshot) {
      var simAttrs = wi.simulation ? wi.simulation.getNamesOfSimulatedAttributes() : immutable_1.List();
      return new PerfWindowItem(wi.id, wi.productId, wi.windowId, wi.promotionId, PerfWindowItemPosAttributes.fromPosAttributes(wi.posAttributes), wi.memberCredits, wi.promoPrice, wi.regularPrice, wi.promoVolume, wi.simulation !== null ? wi.simulation.simulationId : null, snapshot, wi.isFCApprovalRequired(), wi.requestSecondaryPlacement, wi.secondaryPlacement, wi.onPicture, wi.getNumberOfSites(), simAttrs, wi.logisticComment);
    }
  }]);

  return PerfWindowItem;
}(DomainObject_1.DomainObject);

exports.PerfWindowItem = PerfWindowItem; //tslint:disable:max-classes-per-file

/**
 * Projection of SupplierAgreement for performance reports.
 */

var PerfSupplierAgreement =
/*#__PURE__*/
function (_DomainObject_1$Domai5) {
  _inherits(PerfSupplierAgreement, _DomainObject_1$Domai5);

  function PerfSupplierAgreement(id, supplierId, currencyId, windowItemId, preferred, regularPurchasePrice, // shouldn't be null
  promoPurchasePrice, // shouldn't be null
  promoPurchasePricePlus, // shouldn't be null
  promoPurchaseStartDate, promoPurchaseEndDate, promoVolume, secondaryPlacementFee, leafletFee, costPriceFormat, unitBackDiscount) {
    var _this5;

    _classCallCheck(this, PerfSupplierAgreement);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(PerfSupplierAgreement).call(this));
    _this5.id = id;
    _this5.supplierId = supplierId;
    _this5.currencyId = currencyId;
    _this5.windowItemId = windowItemId;
    _this5.preferred = preferred;
    _this5.regularPurchasePrice = regularPurchasePrice;
    _this5.promoPurchasePrice = promoPurchasePrice;
    _this5.promoPurchasePricePlus = promoPurchasePricePlus;
    _this5.promoPurchaseStartDate = promoPurchaseStartDate;
    _this5.promoPurchaseEndDate = promoPurchaseEndDate;
    _this5.promoVolume = promoVolume;
    _this5.secondaryPlacementFee = secondaryPlacementFee;
    _this5.leafletFee = leafletFee;
    _this5.costPriceFormat = costPriceFormat;
    _this5.unitBackDiscount = unitBackDiscount;
    return _this5;
  }

  _createClass(PerfSupplierAgreement, null, [{
    key: "fromSupplierAgreement",
    value: function fromSupplierAgreement(ag) {
      return new PerfSupplierAgreement(ag.id, ag.supplierId, ag.currencyId, ag.windowItemId, ag.preferred, ag.regularPurchasePrice, ag.promoPurchasePrice, ag.promoPurchasePricePlus, ag.promoPurchaseStartDate, ag.promoPurchaseEndDate, ag.promoVolume, ag.secondaryPlacementFee, ag.leafletFee, ag.costPriceFormat, ag.unitBackDiscount);
    }
  }, {
    key: "fromSupplierAgreementNullable",
    value: function fromSupplierAgreementNullable(ag) {
      return ag === null ? null : PerfSupplierAgreement.fromSupplierAgreement(ag);
    }
  }]);

  return PerfSupplierAgreement;
}(DomainObject_1.DomainObject);

exports.PerfSupplierAgreement = PerfSupplierAgreement;
/**
 * Only necessary input domain data for Promotion performance report.
 * @author Radek Beran
 */
//tslint:disable:max-classes-per-file

var PromotionPerformanceReportData =
/*#__PURE__*/
function (_DomainObject_1$Domai6) {
  _inherits(PromotionPerformanceReportData, _DomainObject_1$Domai6);

  /**
   * @param id
   * @param forSnapshot
   * @param forSimulation
   * @param promotion
   * @param promotionWeeklySplits Object for split consists of: windowItemId, start of week, weight.
   * @param windows
   * @param windowItems
   * @param supplierAgreements supplier agreements for particular window items
   */
  function PromotionPerformanceReportData(id, forSnapshot, forSimulation, promotion, promotionWeeklySplits, windows, windowItems, supplierAgreements) {
    var _this6;

    _classCallCheck(this, PromotionPerformanceReportData);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportData).call(this));
    _this6.id = id;
    _this6.forSnapshot = forSnapshot;
    _this6.forSimulation = forSimulation;
    _this6.promotion = promotion;
    _this6.promotionWeeklySplits = promotionWeeklySplits;
    _this6.windows = windows;
    _this6.windowItems = windowItems;
    _this6.supplierAgreements = supplierAgreements;
    _this6.windowsMap = immutable_1.Map(windows.map(function (win) {
      return [win.id, win];
    }));
    _this6.windowItemsMap = immutable_1.Map(windowItems.map(function (wi) {
      return [wi.id, wi];
    }));
    return _this6;
  }

  _createClass(PromotionPerformanceReportData, [{
    key: "getWindowItemFeeSums",
    value: function getWindowItemFeeSums() {
      return this.supplierAgreements.map(function (l) {
        return SupplierAgreement_1.SupplierAgreement.getFeeSums(l);
      });
    }
  }]);

  return PromotionPerformanceReportData;
}(DomainObject_1.DomainObject);

exports.PromotionPerformanceReportData = PromotionPerformanceReportData;